import React, { lazy, Suspense } from 'react';
import PluginMockupShell from './PluginMockupShell';
import { useIdleLoad } from '@/utils/useIdleLoad';

const PluginMockupInteractive = lazy(() => import('./PluginMockupInteractive'));

export const PluginMockupContainer: React.FC = () => {
  const ready = useIdleLoad(2000);

  if (!ready) {
    return <PluginMockupShell />;
  }

  return (
    <Suspense fallback={<PluginMockupShell />}>
      <PluginMockupInteractive />
    </Suspense>
  );
};

export default PluginMockupContainer;
